import cx from 'clsx';
import { Text } from '@paylink/constants';
import { PaylinkLogo } from '@paylink/icons';

import { Image } from '@shared/components/core';

import type { IQueriesCardProps } from './TerminalState.types';

const payNetworks = [
	{
		src: 'https://imgstatic.phonepe.com/images/mercury-ui/icons/80/80/paylinkUpi.png',
		alt: 'UPI',
		width: 34,
		height: 12,
	},
	{
		src: 'https://imgstatic.phonepe.com/images/mercury-ui/icons/80/80/paylinkVisa.png',
		alt: 'Visa',
		width: 36,
		height: 11,
	},
	{
		src: 'https://imgstatic.phonepe.com/images/mercury-ui/icons/80/80/paylinkMastercard.png',
		alt: 'Mastercard',
		width: 24,
		height: 14,
	},
	{
		src: 'https://imgstatic.phonepe.com/images/mercury-ui/icons/80/80/paylinkPciDss.png',
		alt: 'PCI DSS Compliant',
		width: 35,
		height: 16,
	},
];

const QueriesCard = ({ merchantName, isMobile }: IQueriesCardProps) => (
	<div className="bg-white border1 border-grey2 border-radius4 overflow-hidden card-shadow1">
		<p
			className={cx('dark3 m0 h5 lhp130', {
				'px4 pb3 pt4': isMobile,
				'px6 py4': !isMobile,
			})}
		>
			{Text.QUERIES_PREFIX}
			{merchantName}.
		</p>
		<hr className="horizontalLine m0" />
		<div
			className={cx('d-flex flex-column gap2', {
				'px6 py4': !isMobile,
				'px4 pt3 pb4': isMobile,
			})}
		>
			<PaylinkLogo width="80" height="auto" />
			<div className="d-flex items-center gap1">
				{payNetworks.map((network) => (
					<Image key={network.alt} {...network} />
				))}
			</div>
		</div>
	</div>
);

export default QueriesCard;
